import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_FIELD_PROJECT = "GET_LIST_FIELD_PROJECT";
export const GET_DETAIL_FIELD_PROJECT = "GET_DETAIL_FIELD_PROJECT";
export const SAVE_FIELD_PROJECT = "Save_FIELD_PROJECT";
export const DELETE_FIELD_PROJECT = "DELETE_FIELD_PROJECT";
export const UPDATE_FIELD_PROJECT = "UPDATE_FIELD_PROJECT";
export const UPLOAD_IMAGE = "UPLOAD_IMAGE";
export const UPLOAD_LIST_IMAGE = "/admin/upload-multi";
export const SET_LIST_FIELD_PROJECT = "setListFieldProject";
export const SET_DETAIL_FIELD_PROJECT = "setDETAIL_FIELD_PROJECT";



const state = {
    field: [],
    fieldDetail: [],
};

const getters = {
    fields(state) {
        return state.field;
    },
    fieldDetail(state) {
        return state.fieldDetail;
    },
};

const actions = {
    [GET_LIST_FIELD_PROJECT](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_FIELD_PROJECT}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_FIELD_PROJECT, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_FIELD_PROJECT](context,id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_FIELD_PROJECT}/${id}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DETAIL_FIELD_PROJECT, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_FIELD_PROJECT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_FIELD_PROJECT}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPLOAD_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_IMAGE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPLOAD_LIST_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${UPLOAD_LIST_IMAGE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_FIELD_PROJECT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_FIELD_PROJECT}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_FIELD_PROJECT](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_FIELD_PROJECT}`,id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_LIST_FIELD_PROJECT](state, data) {
        state.field = data.data;
    },
    [SET_DETAIL_FIELD_PROJECT](state, data) {
        state.fieldDetail = data.data;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};